import React from "react";
import {Box, Grid, Step, StepConnector, stepConnectorClasses, StepLabel, Stepper, Typography} from "@mui/material";
import {styled} from "@mui/material/styles";
import CheckCircleTwoToneIcon from "@mui/icons-material/CheckCircleTwoTone";
import AdjustOutlinedIcon from "@mui/icons-material/AdjustOutlined";

import coinStacked from "../../assets/images/coinStacked.svg";
import coinGrey from "../../assets/images/coinGrey.svg";
import coinLock from "../../assets/images/coinLock.svg";
import "./dashboard.css";
import {useRefData} from "../../graphql/graphql/ref/hooks";

const steps = [
  {
    title: "Send someone a gift",
    desc: "Friends save 20% on their first month if they use your link",
  },
  {
    title: "Earn a free membership",
    desc: "Reach 3 referrals and your membership is FREE",
  },
  {
    title: "Want to invite more?",
    desc: "We appreciate that. We'll reward your loyalty and pay you",
  },
  {
    title: "Get paid monthly",
    desc: "Get 15% every billing cycle for as long as they stay a member",
  },
];

const QontoConnector = styled(StepConnector)(({theme}) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 13,
    left: "calc(-50% + 11px)",
    right: "calc(50% + 11px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#EDA044",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#EDA044",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === "dark" ? theme.palette.grey[800] : "#242424",
    borderTopWidth: 2,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled("div")(({theme, ownerState}) => ({
  color: theme.palette.mode === "dark" ? theme.palette.grey[700] : "#242424",
  display: "flex",
  height: 28,
  alignItems: "center",
  ...(ownerState.active && {
    color: "#EDA044",
  }),
  "& .QontoStepIcon-completedIcon": {
    color: "#EDA044",
    zIndex: 1,
    fontSize: 28,
  },
  "& .QontoStepIcon-circle": {
    color: "currentColor",
    zIndex: 1,
    fontSize: 28,
  },
}));

function QontoStepIcon(props) {
  const {active, completed, className} = props;

  return (
    <QontoStepIconRoot ownerState={{active}} className={className}>
      {completed ? (
        <CheckCircleTwoToneIcon className="QontoStepIcon-completedIcon" />
      ) : (
        <AdjustOutlinedIcon className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

const referrerData = [
  {
    icon: coinStacked,
    title: "Top Referrer",
    site: "mn**@**.com",
    commissions: "Commissions",
    credits: "55,000 credits",
  },
  {
    icon: coinGrey,
    title: "#2 Referrer",
    site: "mn**@**.com",
    commissions: "Commissions",
    credits: "43,000 credits",
  },
  {
    icon: coinLock,
    title: "#3 Referrer",
    site: "mn**@**.com",
    commissions: "Commissions",
    credits: "40,000 credits",
  },
];

const MembershipStep = () => {
  const {data} = useRefData();
  const getStep = () => {
    if (data?.activeReferralCount >= 3) {
      return 3;
    } else if (data?.activeReferralCount > 1) {
      return 2;
    } else if (data?.activeReferralCount == 1) {
      return 1;
    } else {
      return 0;
    }
  };

  return (
    <Box className="stepperSect">
      <Stepper alternativeLabel activeStep={getStep()} connector={<QontoConnector />}>
        {steps.map((label, key) => (
          <Step key={key}>
            <StepLabel StepIconComponent={QontoStepIcon}>
              {label.title}
              <Typography>{label.desc}</Typography>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      {/* <Grid container spacing={2} mt={1} className="referrerWrap">
        {referrerData.map((referrer, key) => (
          <Grid item key={key} xs={12} md={6} lg={4}>
            <Box
              className="referrerSect"
              display={{ sm: "flex" }}
              alignItems="center"
              justifyContent="center"
            >
              <Box
                className="referrer borderRight"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <img src={referrer.icon} alt="referrer" />
                <Box>
                  <Typography>{referrer.title}</Typography>
                  <Typography variant="h6">{referrer.site}</Typography>
                </Box>
              </Box>
              <Box
                className="referrer"
                display="flex"
                flexDirection="column"
                alignItems="center"
                mt={{ sm: 0, xs: 2 }}
              >
                <Typography>{referrer.commissions}</Typography>
                <Typography variant="h6">{referrer.credits}</Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid> */}
    </Box>
  );
};

export default MembershipStep;
